// Split VERBATIM from utils/datetime-comprehensive.js (ESM barrel split).
import { BUSINESS_TIMEZONE, nowChicago, utcToChicago } from './dateTimeCore';

export function getTimeRemaining(utcTimestamp) {
  if (!utcTimestamp) return 'No due date';
  
  try {
    const chicago = utcToChicago(utcTimestamp);
    const now = nowChicago();
    const diff = chicago.diff(now, ['days', 'hours', 'minutes']);
    
    if (diff.as('milliseconds') < 0) return 'Overdue';
    
    const days = Math.floor(diff.days);
    const hours = Math.floor(diff.hours);
    
    if (days > 0) return `${days} day${days > 1 ? 's' : ''} remaining`;
    if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''} remaining`;
    return 'Due soon';
  } catch (error) {
    console.error('Error getting time remaining:', error);
    return 'Invalid date';
  }
}

/**
 * Check if a due date is overdue
 * @param {string} utcTimestamp - UTC timestamp from database
 * @returns {boolean} - True if overdue
 */

export function isOverdue(utcTimestamp) {
  if (!utcTimestamp) return false;
  
  try {
    const chicago = utcToChicago(utcTimestamp);
    const now = nowChicago();
    return now > chicago;
  } catch (error) {
    console.error('Error checking if overdue:', error);
    return false;
  }
}

/**
 * Check if a due date is due soon (within 24 hours)
 * @param {string} utcTimestamp - UTC timestamp from database
 * @returns {boolean} - True if due soon
 */

export function isDueSoon(utcTimestamp) {
  if (!utcTimestamp) return false;
  
  try {
    const chicago = utcToChicago(utcTimestamp);
    const now = nowChicago();
    const diff = chicago.diff(now, 'hours');
    
    return diff.hours > 0 && diff.hours <= 24;
  } catch (error) {
    console.error('Error checking if due soon:', error);
    return false;
  }
}

/**
 * Get current date string in Chicago timezone (YYYY-MM-DD format)
 * @returns {string} Current date in YYYY-MM-DD format
 */

export function getRelativeTime(dt, base = nowChicago()) {
  const chicago = dt.setZone(BUSINESS_TIMEZONE);
  const baseChicago = base.setZone(BUSINESS_TIMEZONE);
  
  const diff = chicago.diff(baseChicago, ['days', 'hours', 'minutes']);
  
  if (Math.abs(diff.days) >= 1) {
    return `${Math.abs(diff.days)} day${Math.abs(diff.days) !== 1 ? 's' : ''} ${diff.days > 0 ? 'from now' : 'ago'}`;
  } else if (Math.abs(diff.hours) >= 1) {
    return `${Math.abs(diff.hours)} hour${Math.abs(diff.hours) !== 1 ? 's' : ''} ${diff.hours > 0 ? 'from now' : 'ago'}`;
  } else {
    return `${Math.abs(diff.minutes)} minute${Math.abs(diff.minutes) !== 1 ? 's' : ''} ${diff.minutes > 0 ? 'from now' : 'ago'}`;
  }
}

/**
 * Format time with timezone info for tooltips
 * @param {DateTime} dt - DateTime object
 * @returns {Object} - Formatted time with timezone info
 */
